import axios from 'axios';
import IAreaLabel from '../types/AreaLabel';

export interface ILabelService {
    addLabels(
        userEmail: string,
        sessionName: string,
        areaLabels: IAreaLabel[],
    ): Promise<void>;
}

class LabelService implements ILabelService {
    async addLabels(
        userEmail: string,
        sessionName: string,
        areaLabels: IAreaLabel[],
    ): Promise<void> {
        axios.post(`/labeling/${userEmail}/${sessionName}`, areaLabels, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
    }

    async deleteLabels(userEmail: string, sessionName: string): Promise<void> {
        axios.delete(`/labeling/${userEmail}/${sessionName}`);
    }

    async fetchLabels(
        userEmail: string,
        sessionName: string,
    ): Promise<IAreaLabel[]> {
        const areasResponse = await axios.get<IAreaLabel[]>(
            `/labeling/${userEmail}/${sessionName}`,
        );
        return areasResponse.data;
    }
}

const LabelServiceInstance = new LabelService();

export default LabelServiceInstance;
